import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { authService } from '../services';

export const ProtectedRoute = (props) =>
  authService.isTokenValid() ? <Route {...props} /> : <Redirect to="/" />;
